import { Check } from "lucide-react";

/** Hero header of a day card: photo, week badge, day abbreviation, session title, tag row. */
export const DayCardHero = ({ week, dayShort, title, tags = [], done, rest, onClick, testId, titleTestId }) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={testId}
    className="relative block w-full text-left overflow-hidden"
  >
    {rest && (
      <>
        <img
          src="/rest-hero.webp"
          alt=""
          aria-hidden="true"
          loading="lazy"
          draggable={false}
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
        <span className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/45 to-transparent" />
        <span className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A]/70 via-transparent to-transparent" />
      </>
    )}
    <span className={`relative block px-5 ${rest ? 'pt-28' : 'pt-5'} pb-4`}>
      {week != null && (
        <span
          className="inline-block rounded-xl px-3 py-1 font-heading font-black uppercase text-[13px] tracking-[0.08em] backdrop-blur-md"
          style={{
            color: '#FFFFFF',
            border: '1px solid rgba(255,255,255,0.28)',
            background: 'linear-gradient(135deg, rgba(12,18,24,0.72) 0%, rgba(6,10,18,0.78) 100%)',
            boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.12), 0 0 18px rgba(255,255,255,0.10)',
            textShadow: '0 0 14px rgba(255,255,255,0.35)',
          }}
        >
          Week {week}
        </span>
      )}
      <span
        className="mt-1.5 flex items-center gap-2 font-heading font-black uppercase text-5xl leading-[0.92] tracking-tight"
        style={{ color: done ? 'var(--accent-muted)' : 'var(--accent-hex)', textShadow: '0 2px 18px rgba(0,0,0,0.75)' }}
      >
        {done && <Check size={32} strokeWidth={3.5} />}
        {dayShort}
      </span>
      <span
        className="mt-0.5 block font-heading font-black uppercase text-white text-[26px] leading-[1.02] tracking-tight line-clamp-2"
        style={{ textShadow: '0 2px 18px rgba(0,0,0,0.8)' }}
        data-testid={titleTestId}
      >
        {title}
      </span>
      {tags.length > 0 && (
        <span className="mt-1.5 flex items-center flex-wrap gap-x-2 gap-y-0.5 text-[13px] text-white/65 font-medium">
          {tags.map((tag, idx) => (
            <span key={tag} className="flex items-center gap-2">
              {idx > 0 && <span style={{ color: 'var(--accent-hex)' }}>•</span>}
              {tag}
            </span>
          ))}
        </span>
      )}
    </span>
  </button>
);
